import React from 'react';
import { t } from '@lingui/macro';

import {
  SERVICE_TYPE_CHOICES,
  ServiceType,
} from '@rover/constants/src/translations/service.constants';
import { SERVICE_SELECTION_OPTIONS } from '@rover/constants/src/translations/serviceSelector.constants';
import { Box, Flex, Text } from '@rover/kibble/core';
import ServiceIcon from '@rover/shared/js/search/components/ServiceIcon';

import SelectableOption from './SelectableOption';

type Props = {
  selectedService: ServiceType | undefined;
  onSelect: (serviceType: ServiceType) => void;
};

const INCLUDED_SLUGS: ServiceType[] = [
  SERVICE_TYPE_CHOICES.boarding,
  SERVICE_TYPE_CHOICES.traveling,
  SERVICE_TYPE_CHOICES.dropIn,
  SERVICE_TYPE_CHOICES.dayCare,
  SERVICE_TYPE_CHOICES.walking,
];

const getServiceOptions = () =>
  SERVICE_SELECTION_OPTIONS()
    .filter(({ value }) => INCLUDED_SLUGS.includes(value))
    .map(({ value, title }) => ({ slug: value, label: title }));

const ServiceTypeGrid = ({ selectedService, onSelect }: Props): JSX.Element => {
  return (
    <Box>
      <Text size="200" fontWeight="semibold" mb="2x" display="block">
        {t`Who needs`}
      </Text>
      <Flex
        webAs="fieldset"
        role="radiogroup"
        flexWrap="wrap"
        gap="2x"
        sx={{ border: 'none', padding: 0, margin: 0 }}
      >
        {getServiceOptions().map(({ slug, label }) => (
          <Box key={slug} width="calc(50% - 4px)">
            <SelectableOption
              isSelected={selectedService === slug}
              onPress={() => onSelect(slug)}
              label={label}
              icon={<ServiceIcon serviceType={slug} />}
            />
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default ServiceTypeGrid;
